import { Pipe, PipeTransform } from '@angular/core';
import { SharedCommonUtility } from '../../../shared/utils/common.utility';

@Pipe({
  name: 'notNullishOrEmpty',
  standalone: false,
})
export class NotNullishOrEmptyPipe implements PipeTransform {
  transform(value: string | ArrayLike<any>, ...args: unknown[]): boolean {
    return SharedCommonUtility.notNullishOrEmpty(value);
  }
}
